<div class="main">
	<div class="menuHolder">
		<div class="menu">
			<p
				class="menu-btn"
				routerLink="/home/quests"
				routerLinkActive="menu-btn--active"
			>
				<img
					src="/assets/common/quest.png"
					class="menu-icon-small"
					routerLinkActive="menu-icon-small--active"
					alt=""
				/>
				Quest List
			</p>
			<p
				class="menu-btn"
				routerLink="/home/my-quest"
				routerLinkActive="menu-btn--active"
			>
				<img
					src="/assets/common/user.png"
					class="menu-icon-small"
					routerLinkActive="menu-icon-small--active"
					alt=""
				/>
				My Quest
			</p>
			<div class="spacer"></div>
			<img
				class="menu-icon"
				src="assets/common/refresh.png"
				(click)="refreshQuest()"
				alt=""
			/>
		</div>
		<div class="loading" [class.loading--active]="!isLoading">
			Loading...
		</div>
		<hr />
	</div>
	<div class="questHolder">
		<app-list-item
			*ngFor="let quest of quests"
			(click)="questRouting(quest)"
			[location]="quest.ConciseLocation"
			[id]="quest.MissionId"
			[missionType]="quest.MissionType"
		></app-list-item>
	</div>
</div>
